export interface StateDto {
  id: number;
  stateCode: string;
  stateName: string;
}
